import Discojs from 'discojs';
import dotenv from 'dotenv';

dotenv.config();

export const disco = new Discojs({
  userToken: process.env.VUE_APP_DISCOGS_TOKEN,
});

export const searchAlbumDiscogs = async (albumName) => {
  const masters = await disco.searchDatabase({
    title: albumName,
    type: 'master',
  });
  const releases = await disco.searchDatabase({
    title: albumName,
    type: 'release',
  });
  return [...masters.results, ...releases.results];
};

export const getAlbumInfoDiscogs = async id => disco.getMaster(id);

export const getReleaseInfoDiscogs = async id => disco.getRelease(parseInt(id, 10));

export default disco;
